import { useQuery } from '@tanstack/react-query';
import { fetchAuthDropListApi } from 'apis/manager/managerApis';
import { IDropListProps } from 'utils/types/common';
//** 관리자 관리 - 권한 리스트 */

function useAuthDropListQuery() {
  const { status, data, error, isFetching } = useQuery(
    ['authDropData'],
    async () => await fetchAuthDropListApi(),
    {
      select: (data) => {
        const newArr: IDropListProps[] = [];
        data.map((v, i) =>
          newArr.push({
            key: i,
            value: v.code,
            text: v.code_name,
            comment: v.comment,
          }),
        );
        newArr.push({ key: newArr?.length, value: '', text: '권한 없음' });
        return newArr;
      },
      onSuccess: (data) => {
        // console.log(data);
      },
    },
  );
  return { status, data, error, isFetching };
}

export default useAuthDropListQuery;
